import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Editor as Editor$1 } from 'primereact/editor';
import { forwardRef } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { InputWrapper } from '../InputWrapper/InputWrapper.js';

const DEFAULT_HEADER_TEMPLATE = jsxs("span", {
  className: "ql-formats",
  children: [jsx("button", {
    type: "button",
    className: "ql-bold",
    "aria-label": "Bold"
  }), jsx("button", {
    type: "button",
    className: "ql-italic",
    "aria-label": "Italic"
  }), jsx("button", {
    type: "button",
    className: "ql-underline",
    "aria-label": "Underline"
  }), jsx("button", {
    type: "button",
    className: "ql-list",
    value: "bullet",
    "aria-label": "Bullet List"
  })]
});
function getDefaultHeaderTemplate(props) {
  if (typeof props.headerTemplate !== 'undefined') {
    return props.headerTemplate;
  }
  return DEFAULT_HEADER_TEMPLATE;
}
function EditorComponent(props, ref) {
  const headerTemplate = getDefaultHeaderTemplate(props);
  const {
      name,
      value,
      errorMessage,
      horizontal,
      labelClassName,
      bulkMode,
      className: classNameProps,
      disabled,
      invalid: invalidProps,
      readOnly: readOnlyProps,
      onBlur: _,
      wrapperClassName: __,
      errorClassName: ___,
      labelTooltip: ____,
      onTextChange,
      headerTemplate: _____
    } = props,
    restProps = __rest(props, ["name", "value", "errorMessage", "horizontal", "labelClassName", "bulkMode", "className", "disabled", "invalid", "readOnly", "onBlur", "wrapperClassName", "errorClassName", "labelTooltip", "onTextChange", "headerTemplate"]);
  const formContext = useFormContext();
  const isControlled = typeof value !== 'undefined';
  const isReadOnly = Boolean(disabled || readOnlyProps);
  const editorModeKey = isReadOnly ? 'readonly' : 'editable';
  if (isControlled || !formContext || !name) {
    const isInvalid = Boolean(errorMessage || invalidProps);
    return jsx(InputWrapper, Object.assign({}, props, {
      children: jsx(Editor$1, Object.assign({}, restProps, {
        headerTemplate: headerTemplate,
        className: clsx('p-editor-container', classNameProps, isInvalid && 'p-invalid'),
        value: value !== null && value !== void 0 ? value : '',
        readOnly: isReadOnly,
        onTextChange: onTextChange,
        ref: ref
      }), editorModeKey)
    }));
  }
  return jsx(Controller, {
    name: name,
    control: formContext.control,
    rules: {
      required: props.required && !bulkMode
    },
    render: _ref => {
      let {
        field,
        fieldState
      } = _ref;
      var _a, _b;
      return jsx(InputWrapper, Object.assign({
        field: field,
        fieldState: fieldState,
        horizontal: horizontal,
        labelClassName: labelClassName,
        name: name
      }, props, {
        children: jsx(Editor$1, Object.assign({}, restProps, {
          headerTemplate: headerTemplate,
          className: clsx('p-editor-container', classNameProps, (fieldState.invalid || invalidProps) && 'p-invalid'),
          value: (_b = (_a = field.value) !== null && _a !== void 0 ? _a : props.value) !== null && _b !== void 0 ? _b : '',
          readOnly: isReadOnly,
          onTextChange: event => {
            var _a;
            field.onChange((_a = event.htmlValue) !== null && _a !== void 0 ? _a : '');
            if (onTextChange) {
              onTextChange(event);
            }
          },
          ref: ref
        }), editorModeKey)
      }));
    }
  });
}
const Editor = /*#__PURE__*/forwardRef(EditorComponent);

export { Editor };
